import styles from "./Terrazzo.module.css";

export default function Terrazzo({ className = "" }) {
  return <div aria-hidden="true" className={`${styles.terrazzo} ${className}`} />;
}
